<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <b-container class="col-lg-10 mt-5">
        <h3 class="text-info text-center pt-4 my-4">
          {{ this.$route.params.cat }}
        </h3>
        <!-- User Interface controls -->
        <b-row>
          <b-col sm="4" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="80">80</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <el-card id="realtable" style="overflow-x: scroll;" shadow="always">
          <TableHeader :pageOptions="pageOptions" :fields="fields" :items="items" :perPage="perPage" :month="month" 
          :visibleFields="undefined" :downloadCSVMethod="'downloadCSVProducts'" :enableToggle="true"/>
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive
            @filtered="onFiltered"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>
            <template slot-scope="row">
              <b-img
                slot="img"
                :src="row.value"
                width="64"
                height="64"
                alt="image"
              />
            </template>
            <template slot="name" slot-scope="row">
              <h6 class="">{{ row.value }}</h6>
            </template>
            <template slot="category" slot-scope="row" class="">
              <div class="row">{{ row.value }}</div>
            </template>

            <!-- <template slot-scope="row">
               <PrintLabels :id="row.id" :name="row.name" :price="row.price" :barcode="row.barcode"/>
            </template> -->

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                 <PrintLabels v-if="printItemPrice" :id="row.item.id" :name="printItemName" :price="printItemPrice" :barcode="row.item.barcode"/>
                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View Prices
                </a>
                <router-link
                  :to="{
                    name: 'editcommonproduct',
                    params: { product_id: row.item.id, cat: $route.params.cat },
                  }"
                  class="btn btn-sm btn-primary"
                >
                  View & Edit
                </router-link>
                <!-- previous shop category based edit form routing -->
                <!-- <router-link
                  v-if="
                    $route.params.cat != 'Mobiles' &&
                    $route.params.cat != 'Tablets' &&
                    $route.params.cat != 'Desktops' &&
                    $route.params.cat != 'Laptops' &&
                    shopcat == ''
                  "
                  :to="{
                    name: 'editcommonproduct',
                    params: { product_id: row.item.id, cat: $route.params.cat },
                  }"
                  class="btn btn-sm btn-primary"
                >
                  View & Edit
                </router-link>
                <router-link
                  v-if="
                    $route.params.cat == 'Mobiles' ||
                    $route.params.cat == 'Tablets' ||
                    $route.params.cat == 'Desktops' ||
                    $route.params.cat == 'Laptops'
                  "
                  :to="{
                    name: 'editmobiles',
                    params: { product_id: row.item.id, cat: $route.params.cat },
                  }"
                  class="btn btn-sm btn-primary"
                >
                  View & Edit
                </router-link>
                <router-link
                  v-if="shopcat == 'Vehicles'"
                  :to="{
                    name: 'editvehicles',
                    params: { product_id: row.item.id, cat: $route.params.cat },
                  }"
                  class="btn btn-sm btn-primary"
                >
                  View & Edit
                </router-link> -->
                <a
                  size="sm"
                  @click="open(row.item)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a>
                
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card style="background-color: #c9c9c9;">
                <el-button
                  type="success"
                  size="small"
                  style="float: right; margin-bottom: 5px"
                  @click="savePriceDetails(row.item)"
                  >Save</el-button
                >
                <PriceTable
                  style="margin: 0 auto"
                  :priceData="row.item.priceList"
                  :showPriceTable="true"
                  :printMethod="print"
                  :product="row.item"
                  :profitMargin="row.item.profitMargin"
                />
                <!-- <h5 class="text-center text-info">Product Details</h5>
                <div class="col-6 col-sm-4 col-lg-4" style="">
                    <img class="card-img-top" :src="row.item.img" alt="image">
                </div> -->
                <!-- <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
          </ul> -->
              </b-card>
            </template>
          </b-table>
        </el-card>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- <b-col md="6" class="my-1">
          <a  v-if=" this.items == undefined" @click="refresh()" class=" btn btn-sm btn-primary">
         Refresh
        </a>
      </b-col> -->
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
     
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import vueEasyPrint from "vue-easy-print";
import firebase from "firebase/app";
import sizeof from "firestore-size";
import PriceTable from "./PriceTable.vue";
import PrintLabels from "./PrintLabels.vue"
import TableHeader from "./TableHeader.vue";

const items = [];

export default {
  name: "allProducts",
  components: {
    PriceTable,
    vueEasyPrint,
    PrintLabels,
    TableHeader
  },
  data() {
    var checkprice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      emptyText: "Loading Records...",
      items: [],
      month: new Date(),
      printPrd: '',
      printItemPrice: '',
      printItemName: '',
      fields: [
        "index",
        { key: "name", label: "Name", sortable: true },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "totalQnty", label: "Total Qty", sortable: true },
        { key: "altertQunty", label: "Low Alert Qty", sortable: true },
        { key: "subcategory", label: "Sub Category", sortable: true },
        { key: "brand", label: "Brand", sortable: true },
        { key: "price", label: "Price (RS)", sortable: true },
        { key: "rack", label: "Bin/Rack", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      formdata: {
        name: "",
        price: "",
        dis: 0,
        disprice: 0,
        brand: "",
        color: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {},
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 25,
            message: "Length should be 3 to 25",
            trigger: "blur",
          },
        ],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [
          { message: "Please select sub category", trigger: "change" },
        ],
        brand: [{ message: "Please select brand", trigger: "change" }],
        color: [{ message: "Please select picture", trigger: "blur" }],
        desc: [{ message: "Please input description", trigger: "blur" }],
      },
      labelPosition: "top",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      category: "",
      subcategory: "",
      shops: [],
      shopcat: "",

      loading: false,
      loading1: false,
      loading2: false,
      changed: true,

      productId: "",
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    // printItemPrice() {
    //   return this.printPrice
    // }
    // Items(){

    //     return this.$store.state.items[this.$route.params.cat]

    // }
    // items () {
    //   //console.log('items are changed:')
    //   //this.items = this.prditems
    // }
  },
  watch: {
    // items(){
    //     return this.$store.state.items[this.$route.params.cat]
    // }
  },
  methods: {
    // refresh(){
    //     this.loading1 = true
    //     this.changed = false
    //    setTimeout( () => {
    //        this.items = this.$store.state.items[this.$route.params.cat]
    //     this.loading1 = false
    //     this.changed = true
    //      //console.log('this.items]', this.items)
    //     },3000)
    // },
    print(item,row) {
      this.printPrd = item
      this.printItemPrice = row.sellPr
      this.printItemName = `${item.name} ${row.serial? row.serial: ''}`
      // Pass the element id here
      setTimeout(() => {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write(
          "<html><head><title>" + document.title + "</title>"
        );

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById(item.id).innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 300);
      
      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    fileSelect1(event) {
      //console.log('event is', event)
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.visible = "none";
        this.formdata.imageUrl1 = fileReader.result;
        this.visible1 = "block";
      });
      fileReader.readAsDataURL(files[0]);
      //this.image = files[0];
      const imageCompressor = new ImageCompressor();
      imageCompressor
        .compress(files[0], { quality: 0.6 })
        .then((result) => {
          // Handle the compressed image file.
          if (result.size >= 1000000) {
            const imageCompressor = new ImageCompressor();
            imageCompressor
              .compress(result, { quality: 0.5 })
              .then((result) => {
                this.image1 = result;
                //console.log(filename)
                //console.log(result.size)
              });
          } else {
            this.image1 = result;
            //console.log(filename)
            //console.log('else',result.size)
          }
        })

        .catch((err) => {
          // Handle the error
          //console.log("error is" + err)
        });
    },

    otherIMG(event) {
      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (
        files.length > this.maxFiles ||
        this.imgfiles.length >= this.maxFiles ||
        files.length + this.imgfiles.length > this.maxFiles
      ) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[i].size > 5000200) {
            alert("File " + files[i].name + "is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", () => {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              this.visible = "none";
              // this.logoimg = reader.result
              this.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            const imageCompressor = new ImageCompressor();
            imageCompressor
              .compress(files[i], { quality: 0.6, width: 720, height: 1340 })
              .then((result) => {
                // Handle the compressed image file.
                if (result.size >= 1000000) {
                  const imageCompressor = new ImageCompressor();
                  imageCompressor
                    .compress(result, { quality: 0.5 })
                    .then((result) => {
                      const fileReader = new FileReader();

                      // This fires after the blob has been read/loaded.
                      fileReader.addEventListener("load", () => {
                        this.imgfiles.push(fileReader.result);
                        var otherimg = fileReader.result;
                        this.otherimgs.push(otherimg);
                        //console.log('image is',this.otherimgs)
                      });

                      // Start reading the blob as text.
                      fileReader.readAsDataURL(result);

                      ////console.log(filename)
                      //console.log(result.size)
                      //console.log('image is',result)
                    });
                } else {
                  //  const reader = new FileReader();

                  //     // This fires after the blob has been read/loaded.
                  //     reader.addEventListener('loadend', (e) => {
                  //       this.image2 = e.srcElement.result;
                  //      //console.log('else image is',this.image2)
                  //     });

                  //     // Start reading the blob as text.
                  //     reader.readAsText(result);
                  var fileReader = new FileReader();
                  fileReader.addEventListener("load", () => {
                    this.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    this.otherimgs.push(otherimg);
                    //console.log('else image is',this.otherimgs)
                  });
                  fileReader.readAsDataURL(result);
                  ////console.log(filename)
                  //console.log('else',result.size)
                  //console.log('ekse image is',result)
                }
              })

              .catch((err) => {
                // Handle the error
                //console.log("error is" + err)
              });
          }
        }
      }
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
    open(id) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.deleteItem(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    savePriceDetails(item) {
      this.$store.state.secondaryDatabase
        .collection("products")
        .doc(item.id)
        .update({
          priceList: item.priceList,
        })
        .then(() => {
          this.$store.state.items[this.$route.params.cat].find(({ id }) => {
            //console.log('filfkkk')
            return id === item.id;
          }).priceList = item.priceList;
          this.$notify({
            title: "Success",
            message: "Price data updated",
            type: "success",
          });
        })
        .catch((error) => alert(error));
    },
    deleteItem(itm) {
      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase
        .collection("products")
        .doc(itm.id)
        .delete()
        .then(() => {
          //console.log('item deleted', itm.id)
          var newitems = this.items.filter((item) => {
            //console.log('filfkkk')
            return item.id !== itm.id;
          });
          this.items = newitems;
          this.totalRows = this.items.length;
          this.$store.state.items[this.$route.params.cat] = newitems;
          if (this.items.length == 0) {
            //console.log('this.items.length is', this.items.length)
            this.emptyText = "There are no records to show";
          }
          // this.prdstat[firebase.auth().currentUser.uid] -= 1;
          // db.collection("aaa").doc("prdstat").update({
          //   prdno: this.prdstat,
          // });
          //console.log(this.items)
          this.shops[0].catValues[itm.category] -= 1;
          this.shops[0].categories[itm.category][itm.subcategory] -= 1;
          this.shops[0].curProducts -= 1;
          if (
            this.shops[0].curProducts < 5 &&
            this.shops[0].shopcat == "Vehicles"
          ) {
            this.shops[0].cansearch = "no";
          } else if (
            this.shops[0].curProducts < 10 &&
            this.shops[0].shopcat != "Vehicles"
          ) {
            this.shops[0].cansearch = "no";
          }
          this.$store.state.secondaryDatabase
            .collection("shops")
            .doc(this.shops[0].id)
            .update({
              categories: this.shops[0].categories,
              curProducts: this.shops[0].curProducts,
              search: this.shops[0].cansearch,
              catValues: this.shops[0].catValues,
            })
            .then((doc) => {
              this.loading2 = false;
              this.changed = true;
              //console.log('doc is', doc)
            })
            .catch((error) => alert("shop error", error));
          this.$store.state.prdNameList = this.$store.state.prdNameList.filter(
            (p) => p.barcode !== itm.barcode
          );
          let prds = 'prds';
          if(this.$store.state.noDB === true) {
            prds = `prds${firebase.auth().currentUser.uid}`
          } 
          this.$store.state.secondaryDatabase
            .collection("prdlist")
            .doc(prds)
            .set({ data: this.$store.state.prdNameList })
            .then((doc) => {})
            .catch((error) => {
              alert(error);
            });
        })
        .catch((error) => alert("prd error", error));
    },
  },
  mounted() {},
  created() {
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
    }
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
            shoptype: doc.data().shoptype,
            shopcat: doc.data().cat,
            curProducts: doc.data().curProducts,
            catValues: doc.data().catValues,
            cansearch: doc.data().search,
          };
          this.shops.push(data);
          if (this.shops[0].shopcat == "Vehicles") {
            this.shopcat = this.shops[0].shopcat;
          }
          this.category = this.$route.params.cat;
          this.subcategories = this.shops[0].categories[this.$route.params.cat];
          //console.log('this.subcategories is', this.subcategories)
        });
      });
    if (this.$store.state.items[this.$route.params.cat] != undefined) {
      this.items = this.$store.state.items[this.$route.params.cat];
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
      //console.log(' from STATE this.$store.state.items[this.$route.params.cat]', this.$store.state.items[this.$route.params.cat])
    } else if (this.$store.state.items[this.$route.params.cat] == undefined) {
      //   var loadedItems = []
      //    //console.log(' before getter this.items]', this.items)
      //  loadedItems = this.$store.getters.getItems(this.$route.params.cat)
      //   setTimeout( () => {
      //      this.items = this.$store.state.items[this.$route.params.cat]
      //   this.loading1 = false
      //   this.changed = true
      //   //console.log(' from getter this.$store.getters.getItems(this.$route.params.cat)', this.$store.getters.getItems(this.$route.params.cat))
      //   //console.log(' from getter loadedItems]', loadedItems)
      //    //console.log(' from getter this.items]', this.items)
      //   },4000)

      this.$store.state.secondaryDatabase
        .collection("products")
        .where("owner", "==", firebase.auth().currentUser.uid)
        .where("cat", "==", this.$route.params.cat)
        .get()
        .then((querySnapshot) => {
          var newitems = [];
          querySnapshot.forEach((doc) => {
            // //console.log('this.items.length is', state.items.length)
            const data = {
              id: doc.id,
              name: doc.data().name,
              barcode: doc.data().barcode,
              altertQunty: doc.data().altertQunty,
              category: doc.data().cat,
              brand: doc.data().brand,
              price: doc.data().disprice,
              subcategory: doc.data().subcat,
              desc: doc.data().desc,
              profitMargin: doc.data().profitMargin,
              priceList: doc.data().priceList,
              totalQnty: 0,
              rack: doc.data().rack || '',
              _showDetails: false // toggle row details
              // 'img': doc.data().img,
              // 'otherimgs': doc.data().otherimgs,
            };
            data.priceList.forEach(item => data.totalQnty += item.quantity)
            const bytes = sizeof(doc.data());
            console.log("size of doc", bytes, doc.data().name);
            newitems.push(data);
           
            this.items = newitems.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
            this.totalRows = this.items.length;
            this.$store.state.items[this.$route.params.cat] = newitems.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
            //console.log('state.items[cat]',this.$store.state.items[this.$route.params.cat])
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading1 = false;
          this.changed = true;
          //console.log('newitems', newitems)
          //console.log('state.items',this.$store.state.items)
        });
    }
    // db.collection("aaa")
    //   .doc("prdstat")
    //   .get()
    //   .then((doc) => {
    //     this.prdstat = doc.data().prdno;
    //   });
    // //console.log('this.items.length is', this.items.length)
    // if(this.items.length == 0){
    //     this.emptyText = 'There are no records to show'
    // }
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/imgupload.css");
@import url("~@/assets/admin/css/admin-loader.css");
.printprd {
          margin-bottom: -4px !important;
          font-size: 12px;
          font-weight: bold;
          text-align: center; 
          margin-bottom: -4px !important;
          }
</style>


// WEBPACK FOOTER //
// src/components/admin/AllProducts.vue